// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Data\InitialDataController.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { AutomationSystem, AutomationSystemData, AutomationSystemOptions } from 'data/models/AutomationSystem';
import { CoordinationCardStatus, CoordinationCardStatusData, CoordinationCardStatusOptions } from 'data/models/CoordinationCardStatus';
import { Country, CountryData, CountryOptions } from 'data/models/Country';
import { Domain, DomainData, DomainOptions } from 'data/models/Domain';
import { DomainSummary, DomainSummaryData, DomainSummaryOptions } from 'data/models/DomainSummary';
import { MilestoneType, MilestoneTypeData, MilestoneTypeOptions } from 'data/models/MilestoneType';
import { PilotsInitialData, PilotsInitialDataData, PilotsInitialDataOptions } from 'data/models/PilotsInitialData';
import { Role, RoleData, RoleOptions } from 'data/models/Role';
import { UITheme, UIThemeData, UIThemeOptions } from 'data/models/UITheme';
import { UserSummary, UserSummaryData, UserSummaryOptions } from 'data/models/UserSummary';

// InitialDataData is the class that InitialData serializes to/from
export interface InitialDataData {
    Id : number;
	
    AutomationSystems : AutomationSystemData[] | null;
    CoordinationCardStatuses : CoordinationCardStatusData[] | null;
    Countries : CountryData[] | null;
    Domain : DomainData | null;
    DomainSummary : DomainSummaryData | null;
    MilestoneTypes : MilestoneTypeData[] | null;
    Pilots : PilotsInitialDataData | null;
    Roles : RoleData[] | null;
    UIThemes : UIThemeData[] | null;
    UserSummary : UserSummaryData | null;
	
}

// InitialDataOptions is the class which may be passed to the InitialData constructor to define optional initial data values
export interface InitialDataOptions {
    Id : number;
	
    AutomationSystems? : AutomationSystemOptions[] | null;
    CoordinationCardStatuses? : CoordinationCardStatusOptions[] | null;
    Countries? : CountryOptions[] | null;
    Domain? : DomainOptions | null;
    DomainSummary? : DomainSummaryOptions | null;
    MilestoneTypes? : MilestoneTypeOptions[] | null;
    Pilots? : PilotsInitialDataOptions | null;
    Roles? : RoleOptions[] | null;
    UIThemes? : UIThemeOptions[] | null;
    UserSummary? : UserSummaryOptions | null;
	
}

export class InitialData {
    public Id : DataSignal<number>;
	
    public AutomationSystems : SDataArray<AutomationSystem>;
    public CoordinationCardStatuses : SDataArray<CoordinationCardStatus>;
    public Countries : SDataArray<Country>;
    public Domain : DataSignal<Domain | null>;
    public DomainSummary : DataSignal<DomainSummary | null>;
    public MilestoneTypes : SDataArray<MilestoneType>;
    public Pilots : DataSignal<PilotsInitialData | null>;
    public Roles : SDataArray<Role>;
    public UIThemes : SDataArray<UITheme>;
    public UserSummary : DataSignal<UserSummary | null>;
	

    constructor();
    constructor(data : InitialDataOptions);
    constructor(data: InitialDataOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.AutomationSystems = SArray<AutomationSystem>([]);
        this.CoordinationCardStatuses = SArray<CoordinationCardStatus>([]);
        this.Countries = SArray<Country>([]);
        this.Domain = S.value<Domain | null>(null);
        this.DomainSummary = S.value<DomainSummary | null>(null);
        this.MilestoneTypes = SArray<MilestoneType>([]);
        this.Pilots = S.value<PilotsInitialData | null>(null);
        this.Roles = SArray<Role>([]);
        this.UIThemes = SArray<UITheme>([]);
        this.UserSummary = S.value<UserSummary | null>(null);
	    
    }

    static key(obj : InitialData) {
        return obj.Id();
    }
    
    static dataKey(obj : InitialDataOptions) {
        return obj.Id;
    }

    static update(obj : InitialData, data : InitialDataOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/InitialData.ts